// @flow
import React from 'react';
import styled from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';

import { Flex } from '@finect/tabular-core/Flex';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
import { H5 } from '@finect/tabular-core/Headings';
import { HTML } from '@finect/tabular-components/HTML';

import { slugify } from '@finect/front-utils/slugify';

import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { Follow, Stats, HTMLDescriptionSmall } from '../../../components';
import { FollowAction } from '../../../components/Follow/Follow';
import type { TagType } from '../../../types';

/* eslint-disable */
const TopicBlock = styled.div`
  &:not(:last-child) {
    padding-bottom: 18px;
    border-bottom: 1px solid ${({ theme }) => theme.borderLightColor};
    margin-bottom: 18px;
    ${minMediaQueries.phablet`
      padding-bottom: 24px;
      margin-bottom: 24px;
    `};
  }

  ${/* sc-sel */ FollowAction} {
    flex-shrink: 0;
    margin-left: 24px;
  }

  > ${/*sc-sel*/ ParagraphSmall} {
    padding-top: 9px;
  }

  ${/*sc-sel*/ H5} {
    &:first-letter {
      text-transform: uppercase;
    }
  }
`;
/* eslint-enable */

type Props = {
  tag: TagType,
  action: Function,
  isLoggedIn?: boolean,
  nofollow?: boolean
};

export const Topic = ({ tag, action, isLoggedIn, nofollow }: Props) => {
  const handleFollow = () => {
    action(tag.id);
  };

  const rel = nofollow ? { rel: 'nofollow' } : {};

  return (
    <TopicBlock>
      <Flex align="center" justify="space-between">
        <AppLink href={`/preguntas/temas/${tag.id}/${slugify(tag.name)}/mas-activas`} {...rel}>
          <H5>{tag.name}</H5>
        </AppLink>
        {isLoggedIn ? <Follow buttonMini following={tag.following} followAction={handleFollow} /> : null}
      </Flex>
      <Stats stats={tag.stats} />
      {tag.description ? (
        <ParagraphSmall maxWidth="547px">
          {tag.description ? <HTML wrapper={HTMLDescriptionSmall} html={tag.description} /> : null}
        </ParagraphSmall>
      ) : null}
    </TopicBlock>
  );
};
